import { useQuery } from "@tanstack/react-query";
import { fetchOffersByStoreId, fetchAllActiveOffers } from "../utils/offerService";
import { StoreOffer } from "../types/offer";

/**
 * Custom hook to fetch offers for a specific store
 */
export const useStoreOffers = (storeId: string | null) => {
    return useQuery<StoreOffer[], Error>({
        queryKey: ["offers", storeId],
        queryFn: () => (storeId ? fetchOffersByStoreId(storeId) : Promise.resolve([])),
        enabled: !!storeId,
        staleTime: 5 * 60 * 1000, // 5 minutes
    });
};

/**
 * Custom hook to fetch all active offers
 */
export const useAllActiveOffers = () => {
    return useQuery<StoreOffer[], Error>({
        queryKey: ["offers", "all"],
        queryFn: fetchAllActiveOffers,
        staleTime: 5 * 60 * 1000,
    });
};
